import { render, staticRenderFns } from "./CameraCaptureButton.vue?vue&type=template&id=c26a6288&scoped=true"
import script from "./CameraCaptureButton.vue?vue&type=script&lang=js"
export * from "./CameraCaptureButton.vue?vue&type=script&lang=js"
import style0 from "./CameraCaptureButton.vue?vue&type=style&index=0&id=c26a6288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26a6288",
  null
  
)

export default component.exports